module.exports = __webpack_public_path__ + "img/schedule.2de097bf.svg";